import React, { useRef } from 'react';
import cn from 'classnames';
import { FormField } from '@creditflowresearch/uilib/Form/FormField';
import { FormError } from '@creditflowresearch/uilib/Form/FormError';
import { InputLabel as Label } from '@creditflowresearch/uilib/Input/Label';
import { TSelectProps } from './interfaces';
import useSelect from './useSelect';

import styles from './select.module.scss';

type IProps = TSelectProps & {
  component: React.ElementType,
};

const SelectLayout = (selectProps: IProps) => {
  const {
    component: SelectComponent,
    meta,
    isValidateOnChange,
    isNarrow,
    isErrorMessage = true,
    dataTest,
    formFieldClassName,
    className,
    label,
    selectClassName,
  } = selectProps;

  const selectWrapperRef = useRef(null);
  const metaOnChangeProperty = isValidateOnChange ? meta?.dirty : meta?.touched;
  const isError = meta && metaOnChangeProperty && (meta.error || (meta.submitError && !meta.dirtySinceLastSubmit));
  const selectClasses = cn(['Select', selectClassName, { isError }]);

  return (
    <FormField
      isNarrow={ isNarrow }
      isValidationFeedback={ !!isError }
      dataTest={ dataTest }
      className={ formFieldClassName }
    >
      <div className={ cn(styles.selectEncapsulation, className) } ref={ selectWrapperRef }>
        { label && (<Label>{ label }</Label>) }
        <SelectComponent { ...useSelect(selectProps, selectWrapperRef) } className={ selectClasses } />
        { isErrorMessage && <FormError { ...meta } touched={ metaOnChangeProperty } /> }
      </div>
    </FormField>
  );
};

export default SelectLayout;
